package nl.volleyanalyzer.web

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.js
import nl.volleyanalyzer.web.controller.AnalyzerIndexController
import nl.volleyplanner.web.MainApp
import nl.volleyplanner.web.WebApplication
import nl.volleyplanner.web.base.WebPageController
import nl.volleyplanner.web.base.routing.RouteGuard
import nl.volleyplanner.web.lib.getAnalytics

object VolleyAnalyzerApp : WebApplication {
    override val firebaseApp = Firebase.initialize(options = getFirebaseOptions())
    override val firebaseAnalytics = getAnalytics(firebaseApp.js)

    override val rootPages = listOf(
        AnalyzerIndexController()
    )

    override fun getRouteGuards(webPageController: WebPageController): List<RouteGuard> {
        return buildList {  }
    }

    override fun getFirebaseOptions() = FirebaseOptions(
        applicationId = "1:875373469619:web:81492ad72b9bf4676975c6",
        apiKey = "AIzaSyCWHJ1uWhl0LPEu3lnZjqIDcl5ZpfVi6CI",
        projectId = "volleyplanner",
        authDomain = "volleyplanner.firebaseapp.com",
        storageBucket = "volleyplanner.appspot.com",
        gcmSenderId = "875373469619",
        gaTrackingId = "G-K2EZ86TW31"
    )

    override fun init() {
        /**
         * Analyzer routes
         * TODO: Split to own app
         */
//        val indexController = AnalyzerIndexController()
//        page("/") { ctx ->
//            route(ctx, indexController)
//        }
//        page("/poule/:pouleId") { ctx ->
//            route(ctx, PouleAnalyzerController())
//        }
//        page("/poule/:pouleId/match/:matchId") { ctx ->
//            route(ctx, MatchAnalyzerController())
//        }

//        page()
    }
}

fun main() {
    MainApp.init(VolleyAnalyzerApp)
}
